"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var React = __importStar(require("react"));
var utils_1 = require("../../utils");
var Body_1 = __importDefault(require("../Body"));
var Cannabinoids_1 = __importDefault(require("../cards/Cannabinoids"));
var ChemicalResidue_1 = __importDefault(require("../cards/ChemicalResidue"));
var HeavyMetals_1 = __importDefault(require("../cards/HeavyMetals"));
var Microbial_1 = __importDefault(require("../cards/Microbial"));
var ResidualSolvents_1 = __importDefault(require("../cards/ResidualSolvents"));
var Terpenes_1 = __importDefault(require("../cards/Terpenes"));
var FirstPage_1 = __importDefault(require("../FirstPage"));
var Footer_1 = __importDefault(require("../Footer"));
var Header_1 = __importDefault(require("../Header"));
var PanelCard_1 = __importDefault(require("../PanelCard"));
var DraftWatermark_1 = __importDefault(require("../DraftWatermark"));
var T20TestedWatermark_1 = __importDefault(require("../T20TestedWatermark"));
var Density_1 = __importDefault(require("../cards/Density"));
var WaterActivity_1 = __importDefault(require("../cards/WaterActivity"));
var CARDS_MAP = {
    Cannabinoids: { component: Cannabinoids_1.default, order: 1 },
    Terpenes: { component: Terpenes_1.default, order: 2 },
    "Heavy Metals": { component: HeavyMetals_1.default, order: 3 },
    "Residual Solvents": { component: ResidualSolvents_1.default, order: 4 },
    Microbial: { component: Microbial_1.default, order: 5 },
    "Chemical Residue": { component: ChemicalResidue_1.default, order: 6 },
    "Foreign Material": { order: 7 },
    "Moisture Content": { order: 8 },
    "Water Activity": { order: 9, component: WaterActivity_1.default },
    Density: { order: 10, component: Density_1.default },
};
var style = renderer_1.StyleSheet.create({
    page: {
        paddingBottom: 90,
        fontFamily: "Quicksand",
    },
});
var Report = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.pageSize, pageSize = _f === void 0 ? "LETTER" : _f, sample = _a.sample, _g = _a.isDraft, isDraft = _g === void 0 ? true : _g, previewMode = _a.previewMode, previewer = _a.previewer;
    var addPassFail = utils_1.shouldDisplayPassFail(sample);
    return (React.createElement(renderer_1.Document, null,
        React.createElement(renderer_1.Page, { size: pageSize, style: style.page, wrap: false },
            React.createElement(Header_1.default, { isCompliance: sample.isCompliance }),
            React.createElement(Body_1.default, null,
                React.createElement(FirstPage_1.default, { sample: sample, previewMode: previewMode, previewer: previewer }),
                isDraft ? React.createElement(DraftWatermark_1.default, null) : React.createElement(T20TestedWatermark_1.default, null)),
            React.createElement(Footer_1.default, { sampleId: sample.sampleId, qrCode: sample.qrCode, completedDate: (_c = (_b = sample.sampleApproval) === null || _b === void 0 ? void 0 : _b.approvedAt) !== null && _c !== void 0 ? _c : new Date().toISOString() })),
        React.createElement(renderer_1.Page, { size: pageSize, style: style.page, wrap: true },
            React.createElement(Header_1.default, { isCompliance: sample.isCompliance }),
            React.createElement(Body_1.default, null,
                sample.orderedPanels
                    .slice()
                    .sort(function (a, b) {
                    var _a, _b, _c, _d;
                    return ((_b = (_a = CARDS_MAP[a.name]) === null || _a === void 0 ? void 0 : _a.order) !== null && _b !== void 0 ? _b : 10) -
                        ((_d = (_c = CARDS_MAP[b.name]) === null || _c === void 0 ? void 0 : _c.order) !== null && _d !== void 0 ? _d : 10);
                })
                    .map(function (orderedPanel) {
                    var _a, _b;
                    var Card = (_a = CARDS_MAP[orderedPanel.name]) === null || _a === void 0 ? void 0 : _a.component;
                    var result = sample.panelResults.find(function (_a) {
                        var panel = _a.panel;
                        return orderedPanel.id === panel.id;
                    });
                    if (!result)
                        return null;
                    return Card ? (React.createElement(Card, { key: orderedPanel.id, result: result, stateRegulations: sample.complianceType.stateReportingRegulations, accessionDate: sample.accession.accessionedAt, panelCompletedDate: result.completedAt, moistureContentPercentage: (_b = utils_1.getMoistureContent(sample)) !== null && _b !== void 0 ? _b : 0, density: utils_1.getDensity(sample), isSolid: utils_1.isSampleSolid(sample), amountPerPackage: sample.accession.amountPerPackage, amountPerServing: sample.accession.amountPerServing, addPassFail: addPassFail })) : (React.createElement(PanelCard_1.default, { key: result.panel.id, panelName: result.panel.name, instrumentName: result.instrumentUsed.name, method: result.panel.standardOperatingProcedures[0].name, accessionDate: sample.accession.accessionedAt, panelCompletedDate: result.completedAt }));
                }),
                isDraft ? React.createElement(DraftWatermark_1.default, null) : React.createElement(T20TestedWatermark_1.default, null)),
            React.createElement(Footer_1.default, { sampleId: sample.sampleId, qrCode: sample.qrCode, completedDate: (_e = (_d = sample.sampleApproval) === null || _d === void 0 ? void 0 : _d.approvedAt) !== null && _e !== void 0 ? _e : new Date().toISOString() }))));
};
exports.default = Report;
//# sourceMappingURL=index.js.map